export default class WalletController {
  constructor(resource) {
    this._resource = resource;
  }

  promotionDeposit(dados) {
    return this._resource('wallet/promotion-deposit')
      .update(dados)
      .then(res => res.json())
      .catch(error => console.log(error));
  }

  async getAll() {
    return this._resource('wallet/admin')
      .get()
      .then(res => res.json())
      .catch(error => console.log(error));
  }

  async getWalletEvents(walletId) {
    return this._resource(`wallet-event/${walletId}`)
      .get()
      .then(res => res.json())
      .catch(error => console.log(error));
  }

  async adminDeposit(data) {
    return this._resource('wallet/admin-deposit')
      .update(data)
      .then(res => res.body);
  }

  async adminWithdraw(data) {
    return this._resource('wallet/admin-withdraw')
      .update(data)
      .then(res => res.body);
  }
}
